import { createReducer, on } from '@ngrx/store';
import { ProjectVideoActions } from './project-video.actions';
import { ProjectEditFormDataStabilized } from '../../project-edit-form/project-edit-form.actions';
import { projectVideoAdapter } from './project-video.adapter';
import { VideoStatus } from '../../shared/video/enums/video-status.enum';
import { createMergedReducer } from 'src/app/ngrx-helpers/adapters/utils';
import { DeployPreviewConfigErrored } from '../../config/config.actions';
import { VideoState } from '../../shared/video/adapter/reducer';
import { InteractionDialog } from './enums/interaction-dialog.enum';

export interface ProjectVideoState extends VideoState {
  activeInteractionDialog: InteractionDialog;
}

export const initialState: ProjectVideoState = {
  ...projectVideoAdapter.getInitialState(),
  activeInteractionDialog: InteractionDialog.None,
};

const additionalProjectVideoReducer = createReducer(
  initialState,
  on(
    ProjectEditFormDataStabilized,
    ProjectVideoActions.updatePreviewClicked,
    ProjectVideoActions.reconnectClicked,
    (state) => ({
      ...state,
      status: VideoStatus.Connecting,
      connectionProgressPercentage: 0,
    }),
  ),
  on(ProjectVideoActions.updatePreviewClicked, ProjectVideoActions.reconnectClicked, (state) => ({
    ...state,
    retainedMicrophoneActive: state.microphoneActive,
    retainedCameraActive: state.cameraActive,
  })),
  on(ProjectVideoActions.reconnectClicked, (state) => ({
    ...state,
    error: null,
  })),
  on(DeployPreviewConfigErrored, (state) => ({
    ...state,
    status: VideoStatus.Disconnected,
  })),
  on(ProjectVideoActions.repeatInteractionModeClicked, (state) => ({
    ...state,
    activeInteractionDialog:
      state.activeInteractionDialog === InteractionDialog.Repeat
        ? InteractionDialog.None
        : InteractionDialog.Repeat,
  })),
);

export const projectVideoReducer = createMergedReducer(
  projectVideoAdapter.getReducer(),
  additionalProjectVideoReducer,
);
